<div class="agpr-aiGeneratedContentCard">
    <div class="agpr-aiGeneratedContentCard-titleContainer">
        <div class="agpr-aiGeneratedContentCard-title">
            {{ 'Common.ai.generatedContentCard.title.' + contentElement.id | localize }}
        </div>
        <div class="agpr-aiGeneratedContentCard-spacer"></div>
        <div
            class="agpr-aiGeneratedContentCard-contextualButtonsContainer"
        >
            <agpr-button
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-clock-rotate-left'"
                [agprTooltip]="'Common.ai.generatedContentCard.previous'"
                tooltipPosition="top"
                [disabled]="disabled || contentElement.currentIndex <= 0 || !contentElement.history?.length"
                (click)="prev()"
            ></agpr-button>
            <agpr-button
                [style]="buttonTypes.icon"
                [icon]="'fa-regular fa-duotone fa-clock-rotate-left fa-flip-horizontal	'"
                [agprTooltip]="'Common.ai.generatedContentCard.next'"
                tooltipPosition="top"
                [disabled]="disabled || contentElement.currentIndex >= contentElement.history?.length - 1 || !contentElement.history?.length"
                (click)="next()"
            ></agpr-button>
            <agpr-button
                [style]="buttonTypes.icon"
                [icon]="'fa-kit-duotone fa-agpr-ai'"
                [agprTooltip]="'Common.ai.generatedContentCard.regenerate'"
                tooltipPosition="top"
                [disabled]="disabled || contentElement.history?.length === MAX_HISTORY"
                (click)="regenerate()"
            ></agpr-button>
        </div>
    </div>
    <div class="agpr-aiGeneratedContentCard-valueContainer">
        <div
            *ngIf="contentElement.value"
            class="agpr-aiGeneratedContentCard-value"
        >
            <span [innerHTML]="contentElement.value"></span>
        </div>
        <div
            class="agpr-aiGeneratedContentCard-valuePlaceholder"
            *ngIf="!contentElement.value"
            [agprLoading]="contentElement.loading"
            [agprInlineLoadingIndicator]="contentElement.loading"
            [loadingSmallIndicator]="contentElement.loading"
        >
            <span *ngIf="!contentElement.loading">
                {{ contentElement.placeholder | localize }}
            </span>
        </div>
    </div>
</div>